<script lang="ts">
    import { _ } from "svelte-i18n"
    import {onMount} from "svelte";

    import TemplateStandard from "../../shared/TemplateStandard.svelte";
    import {mainMenu} from "../../../stores/store";
    import SettingsGeneral from "./SettingsGeneral.svelte";
    import TemplateHeaderDuo from "../../shared/TemplateHeaderDuo.svelte";
    import Tabs from "../../shared/Tabs.svelte";

    let selectedTab = 'appearance';

    $: tabs = [
        { id: 'appearance', label: $_('Appearance') },
        { id: 'route-planning', label: $_('Route Planning') },
        { id: 'notifications', label: $_('Notifications') },
        { id: 'export', label: $_('Export') },
        { id: 'other', label: $_('Other') },
    ];

    onMount( () => {
        $mainMenu.currentPage = 'PageSettings';
    })

</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                {$_('Settings')}
            </div>
            <div slot="main-buttons">
                <Tabs
                    bind:selectedId={selectedTab}
                    items={tabs}
                    onChange={(id) => { selectedTab = id; }}
                />
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content">
        <SettingsGeneral {selectedTab} />
    </div>
</TemplateStandard>
